import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import leaf1 from '../imaged/leaf.png';
import leaf2 from '../imaged/download-removebg-preview.png';

// Random number helper
function randomBetween(min, max) {
  return Math.random() * (max - min) + min;
}

const FloatingLeaves = ({ count = 12 }) => {
  const leaves = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const left = randomBetween(0, 100);

        return {
          left,
          size: randomBetween(20, 40),
          duration: randomBetween(10, 20),
          delay: randomBetween(0, 5),
          rotate: randomBetween(-25, 25),
        };
      }),
    [count]
  );

  return (
    <Box sx={{ position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 3 }}>
      {leaves.map((leaf, idx) => (
        <Box
          key={idx}
          sx={{
            position: 'absolute',
            left: `${leaf.left}%`,
            top: -80,
            width: leaf.size,
            height: leaf.size,
            backgroundImage: `url(${idx % 2 === 0 ? leaf1 : leaf2})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            opacity: 0.6,
            transform: `rotate(${leaf.rotate}deg)`,
            animation: `fall ${leaf.duration}s linear ${leaf.delay}s infinite`,
            '@keyframes fall': {
              '0%': {
                transform: `translateY(-10vh) rotate(${leaf.rotate}deg)`,
              },
              '100%': {
                transform: `translateY(110vh) rotate(${leaf.rotate + 90}deg)`,
              },
            },
          }}
        />
      ))}
    </Box>
  );
};

export default FloatingLeaves;
